import { StateService } from '@uirouter/angularjs';
import * as angular from 'angular';
import * as _ from 'underscore';
import { AnchorSmoothScrollService } from '../../../../../app.common/modules/common/services/anchorSmoothScroll.service';
import { BackToDashboardService } from '../../../../../app.common/modules/common/services/back-to-dashboard.service';
import { AccountService } from '../../../account/account.service';
import { IUser } from '../../../account/model';
import { IRetailerRootScope } from '../../../core/models';
import { IMenu, NavigationService } from '../../services/navigation.service';

export class SidebarController {
    public static $inject = ['$rootScope', 'anchorSmoothScroll', '$translate', 'accountService', 'navigationService', '$state', 'backToDashboardService'];

    public menu: IMenu[];

    constructor(
        private $rootScope: IRetailerRootScope,
        private anchorSmoothScroll: AnchorSmoothScrollService,
        private $translate: angular.translate.ITranslateService,
        private accountService: AccountService,
        private navigationService: NavigationService,
        private $state: StateService,
        private backToDashboardService: BackToDashboardService
    ) {
        const unwatch = $rootScope.$watch('userData', (userData: IUser) => {
            if (userData && userData.permission) {
                unwatch();
                this.menu = !$state.current.name.startsWith('app.help') ?  navigationService.getMenu() : navigationService.getHelpMenu(false);
            } else {
                this.menu = $state.current.name.startsWith('app.help') ? navigationService.getHelpMenu(true) : [];
            }
        }, true);
    }

    public isOpenLink(menuItem: IMenu) {
        return menuItem.url && menuItem.url.length > 0;
    }

    public clickRoot(menuItem: IMenu) {
        if (menuItem.url !== 'app.advertising.info' && menuItem.url !== 'app.marketing-campaigns.info') {
            menuItem.isOpen = !menuItem.isOpen;
        }
    }

    public isActive(menuItem: IMenu) {
        const current = this.$rootScope.$state.current.name;
        return current.startsWith(menuItem.url)
            || current.startsWith(menuItem.urlBase)
            || menuItem.relatedUrls && _.any(menuItem.relatedUrls, (url: string) => {
                return current.startsWith(url);
            })
            || menuItem.submenu && _.any(menuItem.submenu, (menu) => {
                return this.isActive(menu);
            });
    }

    public logOff(redirectToHomepage?: boolean) {
        this.accountService.logOut(redirectToHomepage);
    }

    public canNavigateBack(): boolean {
        return !!this.backToDashboardService.dashboardLink;
    }
}

angular.module('naut')
    .component('sidebar', {
        template: require('./sidebar.html'),
        controller: SidebarController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/components/sidebar/sidebar.component.ts